import "@arco-design/web-react/es/Breadcrumb/style";
import _Breadcrumb from "@arco-design/web-react/es/Breadcrumb";
import _IconRight from "@arco-design/web-react/icon/react-icon/IconRight";
import _IconTag from "@arco-design/web-react/icon/react-icon/IconTag";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import { intl } from 'di18n-react';
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Switch, Route, Link, Redirect, useHistory } from 'react-router-dom';
import NodeSelector from './components/NodeSelector';
import cs from 'classnames';
import CollapseIcon from '@/assets/collapse.svg';
import { useSelector, useDispatch } from 'react-redux';
import qs from 'query-string';
import Navbar from './components/NavBar';
import useRoute from '@/routes';
import { isArray } from './utils/is';
import useLocale from './utils/useLocale';
import getUrlParams from './utils/getUrlParams';
import lazyload from './utils/lazyload';
import styles from './style/layout.module.less';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { UserService } from './service';
const MenuItem = _Menu.Item;
const SubMenu = _Menu.SubMenu;
const Sider = _Layout.Sider;
const Content = _Layout.Content;
function getIconFromKey(key) {
  switch (key) {
    case 'dashboard':
      return /*#__PURE__*/React.createElement(_IconDashboard, {
        className: styles.icon
      });
    case 'example':
      return /*#__PURE__*/React.createElement(_IconTag, {
        className: styles.icon
      });
    default:
      return /*#__PURE__*/React.createElement("div", {
        className: styles['icon-empty']
      });
  }
}
function getFlattenRoutes(routes) {
  const res = [];
  function travel(_routes) {
    _routes.forEach(route => {
      if (route.key && !route.children) {
        route.component = lazyload(() => import(`./pages/${route.key}`));
        res.push(route);
      } else if (isArray(route.children) && route.children.length) {
        travel(route.children);
      }
    });
  }
  travel(routes);
  return res;
}
function PageLayout() {
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;
  const searchStr = window.location.search;
  const currentComponent = qs.parseUrl(pathname).url.slice(1);
  const locale = useLocale();
  const settings = useSelector(state => state.settings);
  const userInfo = useSelector(state => state.userInfo);
  const dispatch = useDispatch();
  const [license, setLicense] = useState(null);
  const [routes, defaultRoute] = useRoute(null);
  const defaultSelectedKeys = [currentComponent || defaultRoute];
  const paths = (currentComponent || defaultRoute).split('/');
  const defaultOpenKeys = paths.slice(0, paths.length - 1);
  const [breadcrumb, setBreadCrumb] = useState([]);
  const [collapsed, setCollapsed] = useState(false); //菜单的收缩、展开状态
  const [isLock, setIsLock] = useState(false); //菜单是否锁定，锁定了不能再收缩
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const routeMap = useRef(new Map());
  const navbarHeight = 104;
  const [menuWidth, setMenuWidth] = useState(collapsed ? 0 : 200);
  const showNavbar = settings.navbar && urlParams.navbar !== false;
  const showMenu = settings.menu && urlParams.menu !== false;
  const showFooter = settings.footer && urlParams.footer !== false;
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);
  const {
    run: getUserCenterRun
  } = useRequest(UserService.getUserCenter, {
    manual: true,
    onSuccess: res => {
      setLicense(res);
      dispatch({
        type: 'update-userInfo',
        payload: {
          userInfo: res
        }
      });
    }
  });
  useEffect(() => {
    getUserCenterRun();
  }, []);
  useEffect(() => {
    if (localStorage.getItem('arco-lang') == 'zh-CN') {
      setMenuWidth(200);
    } else {
      setMenuWidth(270);
    }
  }, [localStorage.getItem('arco-lang')]);
  useEffect(() => {
    const unlisten = history.listen(historyLocation => {
      const {
        pathname
      } = historyLocation;
      const currentComponent = qs.parseUrl(pathname).url.slice(1);
      setSelectedKeys([currentComponent]);
      setBreadCrumb(routeMap.current.get(pathname) || []);
    });
    return () => {
      unlisten();
    };
  }, [history]);
  function renderRoutes(locale) {
    const nodes = [];
    routeMap.current.clear();
    function travel(_routes, level, parentNode = []) {
      return _routes.map(route => {
        const {
          breadcrumb = true
        } = route;
        const iconDom = getIconFromKey(route.key);
        const titleDom = /*#__PURE__*/React.createElement(React.Fragment, null, iconDom, " ", locale[route.name] || route.name);
        if (route.component && (!isArray(route.children) || isArray(route.children) && !route.children.length)) {
          routeMap.current.set(`/${route.key}`, breadcrumb ? [...parentNode, route.name] : []);
          if (level > 1) {
            return /*#__PURE__*/React.createElement(MenuItem, {
              key: route.key
              // style={{
              //   display: route.key === 'device/node' ? 'none' : '',
              // }}
            }, titleDom);
          }
          nodes.push(/*#__PURE__*/React.createElement(MenuItem, {
            key: route.key
          }, /*#__PURE__*/React.createElement(Link, {
            to: `/${route.key}`
          }, titleDom)));
        }
        if (isArray(route.children) && route.children.length) {
          const parentNode = [];
          if (iconDom.props.isIcon) {
            parentNode.push(iconDom);
          }
          if (level > 1) {
            return /*#__PURE__*/React.createElement(SubMenu, {
              key: route.key,
              title: titleDom
            }, travel(route.children, level + 1, [...parentNode, route.name]));
          }
          nodes.push(/*#__PURE__*/React.createElement(SubMenu, {
            key: route.key,
            title: titleDom
          }, travel(route.children, level + 1, [...parentNode, route.name])));
        }
      });
    }
    travel(routes, 1);
    return nodes;
  }
  function onClickMenuItem(key) {
    const currentRoute = flattenRoutes.find(r => r.key === key);
    const component = currentRoute.component;
    const preload = component.preload();
    preload.then(() => {
      setSelectedKeys([key]);
      history.push(currentRoute.path ? currentRoute.path + searchStr : `/${key}${searchStr}`);
    });
  }
  function toggleCollapse() {
    if (isLock) return;
    setCollapsed(collapsed => !collapsed);
    const newSetting = {
      ...settings,
      menu: collapsed
    };
    dispatch({
      type: 'update-settings',
      payload: {
        settings: newSetting
      }
    });
  }
  function handleChange(value) {
    setIsLock(value);
  }
  const paddingLeft = showMenu ? {
    paddingLeft: menuWidth
  } : {};
  const paddingTop = showNavbar ? {
    paddingTop: navbarHeight
  } : {};
  const paddingStyle = {
    ...paddingLeft,
    ...paddingTop
  };
  const [hideNodeSeletor, setHideNodeSeletor] = useState(true);
  const nodeSeletorWidth = settings?.nodeSelectorWidth ?? 200;
  const contentPaddingLeft = hideNodeSeletor ? 0 : nodeSeletorWidth + 10;
  const [isSelectable, setIsSelectable] = useState(false);
  useEffect(() => {
    const routeConfig = routeMap.current.get(pathname);
    const noNodeSeletorPages = ['/nms/home', '/nms/device/index', '/nms/device/ota', '/nms/device/fota', '/nms/device/node', '/nms/application/appcenter', '/nms/application/appdeploy', '/nms/remote/file', '/nms/remote/command'];
    //没有节点选择组件的页面
    const parentNodeIsSelectablePages = ['/nms/alarm/monitor', '/nms/analysis/monitor', '/nms/device/detail'];
    //节点选择组件可以点击父级的页面
    setBreadCrumb(routeConfig || []);
    setHideNodeSeletor(noNodeSeletorPages.indexOf(pathname) > -1);
    setIsSelectable(parentNodeIsSelectablePages.indexOf(pathname) > -1);
  }, [pathname]);
  return /*#__PURE__*/React.createElement(_Layout, {
    className: styles.layout
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles['layout-navbar'], {
      [styles['layout-navbar-hidden']]: !showNavbar
    })
  }, /*#__PURE__*/React.createElement(Navbar, {
    show: showNavbar
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['breadcrumb-row']
  }, /*#__PURE__*/React.createElement(CollapseIcon, {
    style: {
      cursor: 'pointer'
    },
    onClick: toggleCollapse
  }), !!breadcrumb.length && /*#__PURE__*/React.createElement("div", {
    className: styles['breadcrumb-box']
  }, /*#__PURE__*/React.createElement(_Breadcrumb, {
    separator: /*#__PURE__*/React.createElement(_IconRight, null)
  }, breadcrumb.map((node, index) => /*#__PURE__*/React.createElement(_Breadcrumb.Item, {
    className: styles['breadcrumb-item'],
    key: index
  }, typeof node === 'string' ? locale[node] || node : node)))))), /*#__PURE__*/React.createElement(_Layout, {
    style: {
      minWidth: 1200,
      overflow: 'hidden'
    }
  }, showMenu && /*#__PURE__*/React.createElement(Sider, {
    className: styles['layout-sider'],
    width: menuWidth,
    collapsed: collapsed,
    onCollapse: setCollapsed,
    trigger: null,
    collapsible: true
    // breakpoint="xl"
    ,
    style: paddingTop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['menu-wrapper']
  }, /*#__PURE__*/React.createElement(_Menu, {
    autoOpen: true
    // collapse={collapsed}
    ,
    onClickMenuItem: onClickMenuItem,
    selectedKeys: selectedKeys
    // openKeys={openKeys}
    ,
    onClickSubMenu: (_, openKeys) => setOpenKeys(openKeys)
  }, renderRoutes(locale)), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      bottom: 0,
      textAlign: 'center',
      width: 200,
      color: '#999',
      left: 0,
      fontSize: '12px'
    }
  }, /*#__PURE__*/React.createElement("div", null, intl.t('授权到期日期:'), /*#__PURE__*/React.createElement("span", {
    style: {
      color: license?.is_expired ? 'red' : 'inherit'
    }
  }, license?.userExpired ? license?.userExpired === -1 ? intl.t('永久') : dayjs(license?.userExpired * 1000).format('YYYY-MM-DD') : intl.t('无')))))), /*#__PURE__*/React.createElement(_Layout, {
    className: styles['layout-content'],
    style: paddingStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['layout-content-wrapper']
  }, /*#__PURE__*/React.createElement(Content, null, !hideNodeSeletor ? /*#__PURE__*/React.createElement(NodeSelector, {
    width: nodeSeletorWidth,
    parentNodeIsSelectable: false
  }) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: contentPaddingLeft
    }
  }, /*#__PURE__*/React.createElement(Switch, null, flattenRoutes.map((route, index) => {
    return /*#__PURE__*/React.createElement(Route, {
      key: index,
      path: `/${route.key}`,
      component: route.component
    });
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/nms"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: `/${defaultRoute}`
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/nms/login",
    component: lazyload(() => import('./pages/nms/login/LoginLayout'))
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: `/${defaultRoute}`
  })), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: lazyload(() => import('./pages/exception/403'))
  }))))))));
}
export default PageLayout;